import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=1cc9c0ee&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=1cc9c0ee&prod&lang=scss&scoped=true"
import style1 from "./Carousel.vue?vue&type=style&index=1&id=1cc9c0ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9c0ee",
  null
  
)

export default component.exports